import React, {useState, forwardRef, useImperativeHandle, useEffect, useRef, useMemo} from 'react';
import {Button, Form, Input, Cascader, Tabs, Tooltip, message, Spin, Row, Col} from 'antd';
import DragImageUpload from "@/components/Upload/dragImageUpload";
import {
  getGoodsCategoryTreeList,
  getGoodsManagementDealProductPage,
  getGoodsSaleCategoryDescList,
  goodsSaleCategoryDescDelete,
  goodsSaleCategoryDescSave,
  goodsSaleCategoryDescUpdateById
} from "@/services/goods.ts";
import {useSetState} from "ahooks";
import {debounce, isEmpty} from "lodash-es";
import {getProductManagementPage, salePriceCheck} from "@/services/product.ts";
import DrawerToTab from "@/components/DrawerToTab";
import {SEditor, SMessage} from "shj-components";
import {EditOutlined} from "@ant-design/icons";
import PDFPreview from "@/components/PDFPreview";
import DebounceSearchSelect from "@/pages/baseProduct/components/DebounceSearchSelect";
import {trimStr} from "@/utils/data.ts";
import {getParentId} from "@/utils/common.ts";

const FirstContent = forwardRef((props, ref) => {
  const {detail = {}}: Record<string, any> = props;
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([])

  const [state, setState] = useSetState<any>({
    fileInfos: [],
    descType: [],
    open: false,
    type: '',
    record: {},
    productList: [],
    cateList: [],
    searchProductStr: '',
    infoLoading: false,
    values: {}
  })

  useEffect(() => {
    getOption()
  }, []);

  useEffect(() => {
    if (!isEmpty(detail) && state.cateList?.length) {
      console.log(detail, 'der')
      setState({infoLoading: true})
      const idPath = detail.catId ? getParentId(state.cateList, detail.catId) : []
      form.setFieldsValue({
        ...detail,
        id: props.copyId ? undefined: detail.id,
        mainFiles: detail?.mainFiles?.map(item=>({...item, url: item.urlSite})),
        catId:  idPath?.reverse(),
      })
      setState({values: {...detail, id: props.copyId ? undefined: detail.id } })
      setFileList(detail?.mainFiles?.map(item => ({...item, url: item.urlSite})) || [])
      getDescType()
    }
  }, [detail, state.cateList]);

  const getDescType = () => {
    getGoodsSaleCategoryDescList({busId: detail.id, searchFlag: true, busType: 'GOODS_FILE'}).then(res => {
      getInfo(res.map((item, i) => ({...item, key: i})))
      setState({fileInfos: res.map((item, i) => ({...item, key: i}))})
    }).finally(() => setState({infoLoading: false}))
  }

  const getInfo = (descType: any[]) => {
    const data = descType.map(item => ({
      ...item,
      label: (
          <div>
            <span>{item.name}</span>
            <Tooltip title="编辑">
              <EditOutlined style={{marginLeft: '10px'}} onClick={() => clickToDetail(item.subBusType, item)}/>
            </Tooltip>
          </div>
      ),
      children: getDetailType(item.subBusType, item),
      key: item.id || item.key,
    }))
    setState({descType: data})
  }

  useEffect(() => {
    getProduct(state.searchProductStr)
  }, [state.searchProductStr]);

  const getProduct = debounce(async (nameKey?: string) => {
    const data: any = await getProductManagementPage({pageId: 1, pageSize: 10, data: {enabled: true, nameKey}})
    setState({productList: data.list || []})
  }, 500)

  const getOption = async () => {
    const cateList = await getGoodsCategoryTreeList({enabled: true});
    setState({cateList})
  }

  const openNewWindow = (url: string) => {
    if (url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1) {
      window.open(url)
    } else {
      window.open('http://' + url)
    }
  }

  const getDetailType = (type: string, obj) => {
    const {urlSite, contentInfo} = obj;
    const typeObj = {
      'TYPE_TXT': <SEditor readOnly init={{toolbar: false, menubar: false, plugins:[]}} value={contentInfo}/>,
      'TYPE_PDF': <PDFPreview url={urlSite}/>,
      'TYPE_VIDEO': <video style={{width: '100%'}} src={urlSite} controls={true}/>,
      'TYPE_DESIGN':  <Button type="link" onClick={() => openNewWindow(urlSite)}>{urlSite}</Button>,
    }
    return typeObj[type]
  }

  const clickToDetail = (type = '', record = {}) => {
    if (!type) {
      // 新增
      if (state.descType.length < 5) {
        setState({open: true, type, record})
      } else {
        message.error('最多添加5个')
      }
    } else {
      setState({open: true, type, record})
    }
  }

  const onCloseDescModal = () => {
    setState({open: false, type: '', record: {}})
  }

  const onSaveDesc = (values) => {
    if (detail.id) {
      const apiUrl = values.id ? goodsSaleCategoryDescUpdateById : goodsSaleCategoryDescSave
      return apiUrl({...values, busId: detail.id, busType: 'GOODS_FILE'}).then(res => {
        onCloseDescModal()
        getDescType()
        props.fn?.()
      })
    } else {
      return new Promise((resolve) => {
        console.log(state.fileInfos, values)
        const oldData = state.fileInfos.filter(item => item.key !== values.key)
        const newData = [{...values, key: values.id || values.key || + new Date, busType: 'GOODS_FILE'}]
        setState({fileInfos: oldData.concat(newData)})
        onCloseDescModal()
        getInfo(oldData.concat(newData))
        props.fn?.()
        resolve()
      })
    }
  }

  const onDel = (id: string) => {
    SMessage.confirm({
      onOk: () => {
        if(detail.id){
          return goodsSaleCategoryDescDelete(id).then(res => {
            getDescType()
            props.fn?.()
          })
        } else {
          const filterData = state.fileInfos.filter(item => item.key !== id);
          setState({fileInfos: filterData})
          getInfo(filterData)
        }
      },
    });
  }

  const onEditTab = (targetKey, action: 'add' | 'remove') => {
    console.log(targetKey, 'edit')
    if (action === 'remove') {
      onDel(targetKey)
    }
  }

  const onChangeProduct = async (current) => {
    if(current) {
      try {
        await salePriceCheck(current.productId);
      } catch (err) {
        message.info('无销售指导价，不能新增商品，请切换其它产品');
        return;
      }
      const {goodsName, fileInfos = [], bizTagCode, mainFiles = []} = current;
      const files = fileInfos.filter(item => item.busType === 'GOODS_FILE').map((item, i) => ({...item, key: i}))
      const mainFile: any[] = [{...mainFiles?.[0], url: mainFiles?.[0]?.urlSite}] || []
      getInfo(files)
      setState({fileInfos: files})
      setFileList(mainFile)
      props.setBizTagCode?.(bizTagCode)
      form.setFieldValue('goodsName', goodsName)
      form.setFieldValue('mainFiles', mainFile)
    }
  }

  const filterFileList = useMemo(() => {
    return fileList?.map(item => {
      let obj = {}
      if (item.response && item.status === 'done') {
        const data = item.response.data;
        obj = {url: data.fileUrl, urlSite: data.fileUrl, name: data.originalFilename, busType: 'GOODS_FILE', busId: detail.id}
      } else {
        obj = item
      }
      return obj
    })
  }, [fileList])

  useImperativeHandle(ref, () => {
    const values = form.getFieldsValue() || {}
    return {
      form,
      getFormData: {...values, catId: values.catId?.[values.catId?.length -1], fileInfos: state.fileInfos, mainFiles: filterFileList}
    }
  })

  return (
      <Form
          form={form}
          name="basicInfo"
          layout={'vertical'}
          onValuesChange={(v) => setState({values: v})}
      >
        <Form.Item hidden name='id'><Input/></Form.Item>
        <Row gutter={20}>
          <Col span={8}>
            <Form.Item
                name="productId"
                label="所属产品"
                rules={[
                  {
                    required: true,
                    message: '所属产品不能为空',
                  },
                ]}
            >
              <DebounceSearchSelect
                  fixedParams={{enabled: true, searchFlag: true}}
                  onChange={(_, o) => onChangeProduct(o)}
                  disabled={detail?.editStatus === 'completed'}
                  fetchOptions={getGoodsManagementDealProductPage}
                  label={'所属产品'}
                  nameKey={'showNameKey'}
                  fieldNames={{label: 'goodsName', value: 'productId'}}
                  query={{productId: detail.productId}}/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
                name="catId"
                label="所属品类"
                rules={[
                  {
                    required: true,
                    message: '所属品类不能为空',
                  },
                ]}
            >
              <Cascader expandTrigger={'hover'}
                        displayRender={(labels: string[]) => labels[labels.length - 1]}
                        options={state.cateList}
                        fieldNames={{value: 'id'}}
                        placeholder={'请选择所属品类'}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
                name="goodsName"
                label="商品名称"
                rules={[
                  {
                    required: true,
                    message: '商品名称不能为空',
                  },
                ]}
            >
              <Input placeholder={'请输入商品名称'} maxLength={100} showCount onChange={(e) => form.setFieldValue('goodsName', trimStr(e.target.value))}/>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
            name="mainFiles"
            label="商品主图"
            rules={[
              {
                required: true,
                message: '商品主图不能为空',
                validator: () => {
                  if (fileList.length) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject();
                  }
                }
              },
            ]}
        >
          <DragImageUpload fileList={fileList} onChange={setFileList}
                           limit={5} accept={'.jpg,.jpeg,.png,.BMP'}
              // url={baseURL + `/file-web/fileStore/upload`}
                           toolTip={'支持图片格式：JPEG/PNG/BMP，大小不超过10M，最多5张'}/>
        </Form.Item>
        <Form.Item required={true} label="商品详情">
          <>
            <div><Button type="primary" onClick={() => clickToDetail()}> 添加 </Button></div>
            {state.descType?.length ? <Tabs
                style={{marginTop: 10}}
                items={state.descType}
                type="editable-card"
                onEdit={onEditTab}
                hideAdd
            /> : null}
            <DrawerToTab
                record={state.record}
                open={state.open}
                onCancel={onCloseDescModal}
                title={`${!isEmpty(state.record) ? '编辑' : '新增'}类目介绍`}
                onConfirm={onSaveDesc}
            ></DrawerToTab>
          </>
        </Form.Item>
      </Form>
  )
});

export default FirstContent;